export interface IQuestionnaireItem {
  key: `item_${number}`
  label: string
}

export const QUESTIONNAIRE_ITEMS: IQuestionnaireItem[] = [
  { key: "item_1", label: "Menjadi marah karena hal-hal kecil/sepele" },
  { key: "item_2", label: "Cenderung bereaksi berlebihan pada situasi" },
  { key: "item_3", label: "Kesulitan untuk relaksasi/bersantai" },
  { key: "item_4", label: "Mudah merasa kesal" },
  { key: "item_5", label: "Merasa banyak menghabiskan energi karena cemas" },
  { key: "item_6", label: "Tidak sabaran" },
  { key: "item_7", label: "Mudah tersinggung" },
  { key: "item_8", label: "Sulit untuk beristirahat" },
  { key: "item_9", label: "Mudah marah" },
  { key: "item_10", label: "Kesulitan untuk tenang setelah sesuatu yang mengganggu" },
  { key: "item_11", label: "Sulit mentoleransi gangguan-gangguan terhadap hal yang berada dilingkungan" },
  { key: "item_12", label: "Berada pada keadaan tegang" },
  { key: "item_13", label: "Tidak dapat memaklumi hal apapun yang menghalangi Anda untuk menyelesaikan hal yang sedang Anda lakukan" },
  { key: "item_14", label: "Mudah gelisah" },
]

export const QUESTIONNAIRE_SCALE: { value: number; label: string; description: string }[] = [
  { value: 0, label: "Tidak Pernah", description: "Tidak pernah" },
  { value: 1, label: "Kadang-kadang", description: "Kadang kadang" },
  { value: 2, label: "Sering", description: "Sering" },
  { value: 3, label: "Sering Sekali", description: "Sering sekali" },
]

export const DEFAULT_COMPANY = {
  code: "BRM",
  name: "Bumi Resource Minerals",
}
